import React from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from 'react-redux'

import Dashboard from '../../client/js/pages/dashboard/DashboardHM'
import ManageVehicles from '../../client/js/component/smart/menuComponentsContainer/ManageVehicles'
import Events from '../../client/js/component/dump/menuComponents/Events'
import ManageDriversPage from '../../client/js/pages/drivers/ManageDriversPage'
import Reports from '../../client/js/component/dump/menuComponents/Reports'
import ManageAssetsGroups from '../../client/js/component/dump/menuComponents/ManageAssetsGroups'
import ManageUsers from '../../client/js/component/dump/menuComponents/ManageUsers'
import Firmware from '../../client/js/pages/firmware/Firmware'

import { setMapTypeUsing } from "../../shared/api/action/AccountActions";

const RoleStartPage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = props;

    if (!user) {
        return (<div />)
    }
    const userRole = user.roles[0];
    if (['fleet_maintainer', 'installer'].indexOf(userRole) > -1) {
        return <ManageVehicles />
    }
    if (['storage_manager', 'storage_user'].indexOf(userRole) > -1) {
        return <Events />
    }
    if (['custom_user', 'custom_partner'].includes(userRole)) {
        const userPermissions = user.permissions
        const permissions = userPermissions
            .filter(e => e.perm_category_name !== 'Other' && e.a_view === true)
            .map(({ perm_category_id }) => perm_category_id)

        if (permissions.length && !permissions.includes(1)) {
            if (permissions.includes(2)) {
                return <Events />
            }
            if (permissions.includes(3)) {
                return <Reports />
            }
            if (permissions.includes(4)) {
                return <ManageVehicles location={{ state: { tabKey: 1 } }} />
            }
            if (permissions.includes(5)) {
                return <ManageVehicles />
            }
            if (permissions.includes(6)) {
                return <ManageAssetsGroups />
            }
            if (permissions.includes(11)) {
                return <ManageDriversPage />
            }
            if (permissions.includes(15)) {
                return <ManageVehicles location={{ state: { tabKey: 2 } }} />
            }
            if (permissions.includes(16)) {
                return <ManageUsers />
            }
            if (permissions.includes(17)) {
                return <Firmware />
            }
            navigate('/not-found');
            return;
        }
        else if (!permissions.length) {
            navigate('/not-found');
            return;
        }
    }

    if (location && location.state) {
        return <Dashboard location={location} />
    }

    return <Dashboard />
}

export default connect(
    state => ({
        user: state.user.user,
        renderHomepage: state.dashboardData.renderHomepage, // FWSD-7380, changing of this global state rerenders the Homepage and Map there
    }),
)(RoleStartPage);
